import React, { useEffect, useMemo, useState } from 'react'
import Container from 'react-bootstrap/Container'
import { Form, Button } from 'react-bootstrap'
import { db, storage } from '../../Firebase'
import './style.css'
import { serverTimestamp } from 'firebase/firestore'
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage'
import { collection, addDoc, getDocs } from 'firebase/firestore'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import emailjs from '@emailjs/browser'
import {
  BOOKING_SERVICES,
  DEPOSIT_RATE,
  DEPOSIT_METHODS,
  BALANCE_METHODS,
  ZELLE_INFO,
  CASHAPP_INFO,
  getServicePrice,
  formatMoney,
  calcDeposit,
} from '../../data/bookingServices'
import { sendAppointmentEmails, isGmailGrantError } from '../../utils/emailjs'

const STEPS = [
  { id: 'service', label: 'Service' },
  { id: 'stylist', label: 'Stylist' },
  { id: 'schedule', label: 'Schedule' },
  { id: 'details', label: 'Details' },
  { id: 'payment', label: 'Payment' },
  { id: 'confirm', label: 'Confirm' },
]

const BOOK_URL = 'https://takeachair.com/salon-info?salonId=IHi7PDJMLomwaOqeotpm'

const AppointmentForm = () => {
  const navigate = useNavigate()
  const users = useSelector((state) => state.user)
  const { isLoggedIn } = users

  const [step, setStep] = useState(0)
  const [submitting, setSubmitting] = useState(false)
  const [stylists, setStylists] = useState([])

  const [name, setName] = useState('')
  const [date, setDate] = useState('')
  const [time, setTime] = useState('')
  const [tel, setTel] = useState('')
  const [email, setEmail] = useState('')
  const [desc, setDesc] = useState('')
  const [stylistId, setStylistId] = useState('')
  const [styleImage, setStyleImage] = useState(null)
  const [selectedServices, setSelectedServices] = useState('')
  const [depositMethod, setDepositMethod] = useState('')
  const [balanceMethod, setBalanceMethod] = useState('')

  useEffect(() => {
    if (!isLoggedIn) navigate('/login')
  }, [isLoggedIn, navigate])

  useEffect(() => {
    const fetchStylists = async () => {
      const snapshot = await getDocs(collection(db, 'stylists'))
      setStylists(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })))
    }
    fetchStylists()
  }, [])

  const selectedService = useMemo(
    () => BOOKING_SERVICES.find((s) => s.value === selectedServices),
    [selectedServices]
  )

  const servicePrice = useMemo(() => getServicePrice(selectedService), [selectedService])
  const depositAmount = useMemo(() => calcDeposit(servicePrice), [servicePrice])
  const balanceAmount = useMemo(
    () => Math.round((servicePrice - depositAmount) * 100) / 100,
    [servicePrice, depositAmount]
  )

  const selectedStylist = useMemo(
    () => stylists.find((s) => s.id === stylistId),
    [stylists, stylistId]
  )

  const depositMethodLabel = DEPOSIT_METHODS.find((m) => m.id === depositMethod)?.label
  const balanceMethodLabel = BALANCE_METHODS.find((m) => m.id === balanceMethod)?.label

  const canGoNext = () => {
    if (step === 0) return Boolean(selectedServices)
    if (step === 1) return Boolean(stylistId)
    if (step === 2) return Boolean(date && time)
    if (step === 3) return Boolean(name && email && tel)
    if (step === 4) return Boolean(depositMethod && balanceMethod)
    return true
  }

  const goNext = () => {
    if (!canGoNext()) return
    setStep((prev) => Math.min(prev + 1, STEPS.length - 1))
  }

  const goBack = () => setStep((prev) => Math.max(prev - 1, 0))


  const sendEmail = (message) => {



      var templateParams = {
  name: name,
  message: message,
  recipient: 'nastaanaisie@gmail.com'
};


const EMAILJS_SERVICE_ID = 'service_euhqfak'  
const EMAILJS_APPOINTMENT_TEMPLATE = 'template_n7uzhpo'
const Public="BYtSoeyMNvGQJ9wmo"




  emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_APPOINTMENT_TEMPLATE, templateParams, Public).then(
  (response) => {
    console.log('SUCCESS!', response.status, response.text);
  },
  (error) => {
    console.log('FAILED...', error);
  },
);
   

}

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (submitting) return
    setSubmitting(true)

    try {
      let imageUrl = ''
      if (styleImage) {
        const storageRef = ref(storage, `styles/${styleImage.name}_${Date.now()}`)
        await uploadBytes(storageRef, styleImage)
        imageUrl = await getDownloadURL(storageRef)
      }

      await addDoc(collection(db, 'appointments'), {
        name,
        date,
        time,
        tel,
        email,
        desc,
        services: selectedServices,
        servicePrice,
        depositRate: DEPOSIT_RATE,
        depositAmount,
        balanceAmount,
        depositMethod,
        balanceMethod,
        stylistId,
        styleImageUrl: imageUrl,
        status: 'pending_deposit',
        createdAt: serverTimestamp(),
      })

      const message = [
        `Appointment for ${date} at ${time}.`,
        `Service: ${selectedServices} (${formatMoney(servicePrice)}).`,
        `Deposit (${Math.round(DEPOSIT_RATE * 100)}%): ${formatMoney(depositAmount)} via ${depositMethodLabel}.`,
        `Balance due: ${formatMoney(balanceAmount)} via ${balanceMethodLabel}.`,
        `Stylist: ${selectedStylist?.name || stylistId}.`,
        `Details: ${desc || 'None'}.`,
        `Name: ${name}. Phone: ${tel}.`,
      ].join(' ')

     // const emailResults = await sendAppointmentEmails({ name, email, desc, message })



sendEmail(message)




      // if (emailResults.customer && emailResults.salon) {
      //   alert('Appointment booked! Please send your deposit to confirm your slot.')
      // } else if (isGmailGrantError(emailResults.error)) {
      //   alert(
      //     'Your appointment was saved, but confirmation emails could not be sent (Gmail needs to be reconnected in EmailJS). Please call 703-936-3026 to confirm your booking and deposit.'
      //   )
      // } else {
      //   alert(
      //     'Your appointment was saved, but we could not send a confirmation email. Please call 703-936-3026 to confirm your slot.'
      //   )
      // }
      setName('')
      setDate('')
      setTime('')
      setEmail('')
      setTel('')
      setDesc('')
      setSelectedServices('')
      setStylistId('')
      setStyleImage(null)
      setDepositMethod('')
      setBalanceMethod('')
      setStep(0)
    } catch (error) {
      console.error('Error booking appointment:', error)
      alert('Failed to book appointment. Please try again.')
    } finally {
      setSubmitting(false)
    }
  }

  const renderPriceLabel = (service) => {
    if (service.price != null) return formatMoney(service.price)
    return `From ${formatMoney(service.priceFrom)}`
  }

  const renderDepositInstructions = () => {
    if (depositMethod === 'zelle') {
      return (
        <div className="payment-instructions">
          <strong>Send {formatMoney(depositAmount)} via Zelle to:</strong>
          <p>{ZELLE_INFO}</p>
          <span>Include your name and appointment date in the memo.</span>
        </div>
      )
    }
    if (depositMethod === 'cashapp') {
      return (
        <div className="payment-instructions">
          <strong>Send {formatMoney(depositAmount)} via Cash App to:</strong>
          <p>{CASHAPP_INFO}</p>
          <span>Include your name and appointment date in the note.</span>
        </div>
      )
    }
    if (depositMethod === 'card') {
      return (
        <div className="payment-instructions">
          <strong>Card deposit: {formatMoney(depositAmount)}</strong>
          <p>Our team will contact you to complete your card payment, or you can pay when you call to confirm at 703-936-3026.</p>
        </div>
      )
    }
    return null
  }

  return (
    <Container className="booking-wrap py-4">
      <div className="booking-header">
        <span className="booking-label">Book Online</span>
        <h2>Schedule Your Appointment</h2>
        <p>A {Math.round(DEPOSIT_RATE * 100)}% deposit is required to secure your booking.</p>
        <a href={BOOK_URL} target="_blank" rel="noopener noreferrer" className="booking-alt-link">
          Or book instantly on Take a Chair
        </a>
      </div>

      <div className="booking-stepper" aria-label="Booking progress">
        {STEPS.map((item, index) => (
          <div key={item.id} className={`booking-step ${index <= step ? 'is-active' : ''} ${index === step ? 'is-current' : ''}`}>
            <span className="booking-step-number">{index + 1}</span>
            <span className="booking-step-label">{item.label}</span>
          </div>
        ))}
      </div>

      {selectedService && step > 0 && (
        <div className="booking-price-bar">
          <span>{selectedServices}</span>
          <span className="booking-price-bar-amount">{renderPriceLabel(selectedService)}</span>
          <span className="booking-price-bar-deposit">Deposit: {formatMoney(depositAmount)}</span>
        </div>
      )}

      <Form onSubmit={handleSubmit} className="booking-form">
        {step === 0 && (
          <section className="booking-panel">
            <h3>Select a service</h3>
            <p className="booking-panel-desc">Prices shown — a {Math.round(DEPOSIT_RATE * 100)}% deposit is required to book.</p>
            <div className="service-grid">
              {BOOKING_SERVICES.map((service) => (
                <button
                  key={service.value}
                  type="button"
                  className={`service-card ${selectedServices === service.value ? 'is-selected' : ''}`}
                  onClick={() => setSelectedServices(service.value)}
                >
                  <div className="service-card-top">
                    <strong>{service.value}</strong>
                    <span className="service-price">{renderPriceLabel(service)}</span>
                  </div>
                  <span>{service.desc}</span>
                  <span className="service-deposit-hint">Deposit: {formatMoney(calcDeposit(getServicePrice(service)))}</span>
                </button>
              ))}
            </div>
          </section>
        )}

        {step === 1 && (
          <section className="booking-panel">
            <h3>Choose your stylist</h3>
            <p className="booking-panel-desc">Select a stylist or choose no preference.</p>
            <div className="stylist-grid">
              <button
                type="button"
                className={`stylist-card ${stylistId === 'no-preference' ? 'is-selected' : ''}`}
                onClick={() => setStylistId('no-preference')}
              >
                <div className="stylist-avatar">★</div>
                <strong>No preference</strong>
                <span>We will assign the best available stylist</span>
              </button>
              {stylists.map((stylist) => (
                <button
                  key={stylist.id}
                  type="button"
                  className={`stylist-card ${stylistId === stylist.id ? 'is-selected' : ''}`}
                  onClick={() => setStylistId(stylist.id)}
                >
                  <div className="stylist-avatar">
                    {stylist.profileImage ? (
                      <img src={stylist.profileImage} alt={stylist.name} />
                    ) : (
                      stylist.name?.charAt(0) || 'S'
                    )}
                  </div>
                  <strong>{stylist.name}</strong>
                  <span>{stylist.bio || 'Professional stylist'}</span>
                </button>
              ))}
            </div>
          </section>
        )}

        {step === 2 && (
          <section className="booking-panel">
            <h3>Pick date & time</h3>
            <p className="booking-panel-desc">Choose when you would like to come in.</p>
            <div className="schedule-grid">
              <Form.Group>
                <Form.Label>Date</Form.Label>
                <Form.Control type="date" value={date} onChange={(e) => setDate(e.target.value)} required />
              </Form.Group>
              <Form.Group>
                <Form.Label>Time</Form.Label>
                <Form.Control type="time" value={time} onChange={(e) => setTime(e.target.value)} required />
              </Form.Group>
            </div>
          </section>
        )}

        {step === 3 && (
          <section className="booking-panel">
            <h3>Your details</h3>
            <p className="booking-panel-desc">Tell us how to reach you and share style notes.</p>
            <div className="details-grid">
              <Form.Group>
                <Form.Label>Full name</Form.Label>
                <Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} required />
              </Form.Group>
              <Form.Group>
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </Form.Group>
              <Form.Group>
                <Form.Label>Phone</Form.Label>
                <Form.Control type="tel" value={tel} onChange={(e) => setTel(e.target.value)} required />
              </Form.Group>
              <Form.Group className="details-full">
                <Form.Label>Notes (optional)</Form.Label>
                <Form.Control as="textarea" rows={3} value={desc} onChange={(e) => setDesc(e.target.value)} placeholder="Hair length, style reference, special requests..." />
              </Form.Group>
              <Form.Group className="details-full">
                <Form.Label>Reference image (optional)</Form.Label>
                <Form.Control type="file" accept="image/*" onChange={(e) => setStyleImage(e.target.files[0])} />
              </Form.Group>
            </div>
          </section>
        )}

        {step === 4 && (
          <section className="booking-panel">
            <h3>Payment</h3>
            <p className="booking-panel-desc">
              A {Math.round(DEPOSIT_RATE * 100)}% deposit ({formatMoney(depositAmount)}) is required to book. Deposit can be paid via Zelle, Cash App, or Card.
            </p>

            <div className="payment-summary">
              <div className="payment-summary-row">
                <span>Service total</span>
                <strong>{formatMoney(servicePrice)}</strong>
              </div>
              <div className="payment-summary-row payment-summary-deposit">
                <span>Deposit due now ({Math.round(DEPOSIT_RATE * 100)}%)</span>
                <strong>{formatMoney(depositAmount)}</strong>
              </div>
              <div className="payment-summary-row">
                <span>Balance at visit</span>
                <strong>{formatMoney(balanceAmount)}</strong>
              </div>
            </div>

            <h4 className="payment-section-title">Deposit payment method</h4>
            <p className="payment-section-desc">Cash is not accepted for deposits.</p>
            <div className="payment-grid">
              {DEPOSIT_METHODS.map((method) => (
                <button
                  key={method.id}
                  type="button"
                  className={`payment-card ${depositMethod === method.id ? 'is-selected' : ''}`}
                  onClick={() => setDepositMethod(method.id)}
                >
                  <strong>{method.label}</strong>
                  <span>{method.desc}</span>
                </button>
              ))}
            </div>

            {renderDepositInstructions()}

            <h4 className="payment-section-title">Balance payment method</h4>
            <p className="payment-section-desc">How you plan to pay the remaining balance.</p>
            <div className="payment-grid payment-grid-balance">
              {BALANCE_METHODS.map((method) => (
                <button
                  key={method.id}
                  type="button"
                  className={`payment-card ${balanceMethod === method.id ? 'is-selected' : ''}`}
                  onClick={() => setBalanceMethod(method.id)}
                >
                  <strong>{method.label}</strong>
                  <span>{method.desc}</span>
                </button>
              ))}
            </div>
          </section>
        )}

        {step === 5 && (
          <section className="booking-panel">
            <h3>Review & confirm</h3>
            <p className="booking-panel-desc">Please confirm your booking and payment details.</p>
            <div className="review-card">
              <p><strong>Service:</strong> {selectedServices} — {formatMoney(servicePrice)}</p>
              <p><strong>Stylist:</strong> {selectedStylist?.name || (stylistId === 'no-preference' ? 'No preference' : '—')}</p>
              <p><strong>Date:</strong> {date}</p>
              <p><strong>Time:</strong> {time}</p>
              <p><strong>Name:</strong> {name}</p>
              <p><strong>Email:</strong> {email}</p>
              <p><strong>Phone:</strong> {tel}</p>
              {desc && <p><strong>Notes:</strong> {desc}</p>}
            </div>
            <div className="review-card review-card-payment">
              <p><strong>Deposit ({Math.round(DEPOSIT_RATE * 100)}%):</strong> {formatMoney(depositAmount)} via {depositMethodLabel}</p>
              <p><strong>Balance due:</strong> {formatMoney(balanceAmount)} via {balanceMethodLabel}</p>
            </div>
            <p className="booking-note">
              Your appointment is reserved once we receive your {formatMoney(depositAmount)} deposit. Call{' '}
              <a href="tel:7039363026">703-936-3026</a> with any questions.
            </p>
          </section>
        )}

        <div className="booking-actions">
          {step > 0 && (
            <Button type="button" variant="outline-dark" className="booking-btn-back" onClick={goBack}>
              Back
            </Button>
          )}
          {step < STEPS.length - 1 ? (
            <Button type="button" className="booking-btn-next btn-rita" onClick={goNext} disabled={!canGoNext()}>
              Continue
            </Button>
          ) : (
            <Button type="submit" className="booking-btn-next btn-rta btn-rita" disabled={submitting}>
              {submitting ? 'Booking...' : 'Confirm Booking'}
            </Button>
          )}
        </div>
      </Form>
    </Container>
  )
}

export default AppointmentForm
